module.exports = __webpack_public_path__ + "img/title-bg.f4b07b36.png";